import { Search, SentimentDissatisfied } from "@mui/icons-material";
import {
  CircularProgress,
  Grid,
  InputAdornment,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Products.css";
import ProductCard from "./ProductCard";
import Cart,{generateCartItemsFrom} from "./Cart"
// Definition of Data Structures used
/**
 * @typedef {Object} Product - Data on product available to buy
 * 
 * @property {string} name - The name or title of the product


/**
 * @typedef {Object} CartItem -  - Data on product added to cart
 * 
 * @property {string} name - The name or title of the product in cart
 * @property {string} qty - The quantity of product added to cart
 * @property {string} category - The category that the product belongs to
 * @property {number} cost - The price to buy the product
 * @property {number} rating - The aggregate rating of the product (integer out of five)
 * @property {string} image - Contains URL for the product image
 * @property {string} _id - Unique ID for the product
 */


const Products = () => {
  let { enqueueSnackbar } = useSnackbar();
  let [circleLoading, setCircleLoading]=useState(true);
  let [prodArr,setProdArr]=useState([]);
  let [searchProduct,setSearchProduct]=useState("");
  let [found,setFound]=useState(true);
  let [debTimeOut,setDebTimeOut]=useState(0);
  let [allItems,setAllItems]=useState([]);

  useEffect(()=>{
    performAPICall();
  },[]);
  // TODO: CRIO_TASK_MODULE_PRODUCTS - Fetch products data and store it
  /**
   * Make API call to get the products list and store it to display the products
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on all available products
   *
   * API endpoint - "GET /products"
   *
   * Example for successful response from backend:
   * HTTP 200
   * [
   *      {
   *          "name": "iPhone XR",
   *          "category": "Phones",
   *          "cost": 100,
   *          "rating": 4,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "v4sLtEcMpzabRyfx"
   *      },
   *      {
   *          "name": "Basketball",
   *          "category": "Sports",
   *          "cost": 100,
   *          "rating": 5,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "upLK9JbQ4rMhTwt4"
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 500
   * {
   *      "success": false,
   *      "message": "Something went wrong. Check the backend console for more details"
   * }
   */
  const performAPICall = async () => {
    try{
      let curl=config.endpoint+'/products';
      let response=await axios.get(curl);
      setProdArr(response.data);
      fetchCart(localStorage.getItem("token"),response.data);
      setCircleLoading(false);
    }catch(e){
      enqueueSnackbar(e.response.data.message);
    }
  };

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Implement search logic
  /**
   * Definition for search handler
   * This is the function that is called on adding new search keys
   *
   * @param {string} text
   *    Text user types in the search bar. To filter the displayed products based on this text.
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on filtered set of products
   *
   * API endpoint - "GET /products/search?value=<search-query>"
   *
   */
   useEffect(()=>{
    performSearch(searchProduct)
  },[searchProduct]);


  const performSearch = async (text) => {
    let item=text.toLowerCase()
    let url=config.endpoint+'/products';
    if(text!==''){
      url=config.endpoint+'/products/search?value='+item;
    }
    else{
      url=config.endpoint+'/products';
    }
    try{
      let resp=await axios.get(url);
      setProdArr(resp.data);
      setFound(true);
    }catch(e){
      setFound(false);
    }
  };


  // TODO: CRIO_TASK_MODULE_PRODUCTS - Optimise API calls with debounce search implementation
  /**
   * Definition for debounce handler
   * With debounce, this is the function to be called whenever the user types text in the searchbar field
   *
   * @param {{ target: { value: string } }} event
   *    JS event object emitted from the search input field
   *
   * @param {NodeJS.Timeout} debounceTimeout
   *    Timer id set for the previous debounce call
   *
   */
  function handleChange(e){
    debounceSearch(e,debTimeOut);
  }
  const debounceSearch = (event, debounceTimeout) => {
    if (debounceTimeout !== 0) {
      clearTimeout(debounceTimeout);
    }

    let newTimer = setTimeout(() => {
      setSearchProduct(event.target.value);
    }, 500);

    setDebTimeOut(newTimer);
  };


  const customSearchBar=(
    <TextField
      className="search-desktop"
      size="small"
      fullWidth
      onChange={handleChange}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <Search color="primary" />
          </InputAdornment>
        ),
      }}
      placeholder="Search for items/categories"
      name="search"
    />);

   async function fetchCart(token,productsData){
    let curl=config.endpoint+'/cart';
    let response=await axios.get(curl, {
      headers: {'Authorization': `Bearer ${token}`}
    });
    let arr=generateCartItemsFrom(response.data,productsData);
    setAllItems(arr);
    }



    function addToCart(props){
      if(localStorage.getItem("token")===null){enqueueSnackbar("Login to add an item to the Cart",{variant:'warning'})}
      else{
        for(let i=0;i<allItems.length;i++){
          if(allItems[i]._id===props){
            enqueueSnackbar("Item already in cart. Use the cart sidebar to update quantity or remove item.",{variant:'warning'});
            return;
          }
        }
        for(let i=0;i<prodArr.length;i++){
          if(prodArr[i]._id===props){
            let url=config.endpoint+'/cart';
            axios.post(url, {
              'productId':props,'qty':1
            }, {
              headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}` 
              }
            });
            setAllItems([...allItems,{...prodArr[i],productId:props,qty:1}]);
            
          }
        }
      }
    }

    const handleAddOrSub={
      handleAdd:(id,val)=>{
        for(let i=0;i<allItems.length;i++){
          if(allItems[i]._id===id){
            allItems[i].qty=val+1;
            let url=config.endpoint+'/cart';
            axios.post(url, {
              'productId':id,'qty':val+1
            }, {
              headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}` 
              }
            });
            setAllItems([...allItems]);
          }
        }
      },
      handleSub:(id,val)=>{
        for(let i=0;i<allItems.length;i++){
          if(allItems[i]._id===id){
            if(allItems[i].qty===1){
              allItems.splice(i,1);
            }else{
            allItems[i].qty=val-1;
          }
            let url=config.endpoint+'/cart';
            axios.post(url, {
              'productId':id,'qty':val-1
            }, {
              headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}` 
              }
            });
            setAllItems([...allItems]);
          }
        }
      }
    }

  return (
    <div>
      <Header>
        {/* TODO: CRIO_TASK_MODULE_PRODUCTS - Display search bar in the header for Products page */}
      {customSearchBar}
      </Header>

      {/* Search view for mobiles */}
      <TextField
        className="search-mobile"
        size="small"
        fullWidth
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Search color="primary" />
            </InputAdornment>
          ),
        }}
        onChange={handleChange}
        placeholder="Search for items/categories"
        name="search"
      />
      <Grid container>
        <Grid item className="product-grid" sm={12} md={localStorage.getItem("token")!==null?9:12}>
           <Box className="hero">
             <p className="hero-heading">
               India’s <span className="hero-highlight">FASTEST DELIVERY</span>{" "}
               to your door step
             </p>
           </Box>
           {circleLoading? (
          <div className="loading">
          <CircularProgress color="success"/>
          <br/>
          <p>Loading products</p>
          </div>
          ):(!found? (<div className="loading"><SentimentDissatisfied/><p>No products found</p></div>):(<><Grid container spacing={2} marginY={1} paddingX={1}>
           {prodArr.map((prod)=>(<Grid item key={prod._id} xs={6} md={4} lg={3}><ProductCard product={prod} handleAddToCart={addToCart}/></Grid>))}
           </Grid></>))}
        </Grid>
        <Grid item xs={12} md={3} bgcolor='#E9F5E1'>
         {localStorage.getItem("token")!==null?(<Cart products={allItems} items={allItems} handleQuantity={handleAddOrSub}/>):(<></>)}
        </Grid>
      </Grid>
      <Footer />
    </div>
  );
};

export default Products;
